import OrderCargoOrderHistoryResponse, {
  OrderCargoOrderHistoryResponseBillingModel,
  OrderCargoOrderHistoryResponseEventType,
  OrderCargoOrderHistoryResponseItem,
  OrderCargoOrderHistoryResponseItemPerformedCommand,
} from "../../../../api/raily/order/cargo-order/history/order-cargo-order-history.response";
import BillingModel from "../../../../types/billing-model";
import OrderCargoOrderHistory, {
  OrderCargoOrderHistoryEventType,
  OrderCargoOrderHistoryItem,
  OrderCargoOrderHistoryItemPerformedCommand,
} from "./order-cargo-order-history";

const createDataItemPerformedCommand = (
  performedCommand: OrderCargoOrderHistoryResponseItemPerformedCommand,
): OrderCargoOrderHistoryItemPerformedCommand => {
  switch (performedCommand.commandType) {
    case OrderCargoOrderHistoryResponseEventType.BIND_PASSENGER:
      return { commandType: OrderCargoOrderHistoryEventType.BIND_PASSENGER };

    case OrderCargoOrderHistoryResponseEventType.CANCEL_ORDER:
      return { commandType: OrderCargoOrderHistoryEventType.CANCEL_ORDER };

    case OrderCargoOrderHistoryResponseEventType.CHANGE_TARGET_TAXI:
      return {
        commandType: OrderCargoOrderHistoryEventType.CHANGE_TARGET_TAXI,
      };

    case OrderCargoOrderHistoryResponseEventType.MERGE_ORDERS:
      return { commandType: OrderCargoOrderHistoryEventType.MERGE_ORDERS };

    case OrderCargoOrderHistoryResponseEventType.REQUEST_CANCEL_ORDER:
      return {
        commandType: OrderCargoOrderHistoryEventType.REQUEST_CANCEL_ORDER,
      };

    case OrderCargoOrderHistoryResponseEventType.REVERT_CANCEL_ORDER_REQUEST:
      return {
        commandType:
          OrderCargoOrderHistoryEventType.REVERT_CANCEL_ORDER_REQUEST,
      };

    case OrderCargoOrderHistoryResponseEventType.DEALER_APPROVAL:
      return {
        commandType: OrderCargoOrderHistoryEventType.DEALER_APPROVAL,
        approvingDealerId: performedCommand.approvingDealerId,
      };

    case OrderCargoOrderHistoryResponseEventType.DISPATCH_APPROVAL:
      return {
        commandType: OrderCargoOrderHistoryEventType.DISPATCH_APPROVAL,
        approvingDispatcherId: performedCommand.approvingDispatcherId,
      };

    case OrderCargoOrderHistoryResponseEventType.EXTERNAL_ID_UPDATE:
      return {
        commandType: OrderCargoOrderHistoryEventType.EXTERNAL_ID_UPDATE,
        newExternalId: performedCommand.newExternalId,
      };

    case OrderCargoOrderHistoryResponseEventType.OPERATIONAL_APPROVAL:
      return {
        commandType: OrderCargoOrderHistoryEventType.OPERATIONAL_APPROVAL,
        approvingOperatorId: performedCommand.approvingOperatorId,
      };

    case OrderCargoOrderHistoryResponseEventType.SHUFFLE_MERGE:
      return {
        commandType: OrderCargoOrderHistoryEventType.SHUFFLE_MERGE,
        representation: performedCommand.representation,
      };

    case OrderCargoOrderHistoryResponseEventType.INITIALIZE:
      return {
        commandType: OrderCargoOrderHistoryEventType.INITIALIZE,
        externalId: performedCommand.externalId,
        ride: performedCommand.ride,
      };

    case OrderCargoOrderHistoryResponseEventType.CHANGE_RIDE:
      return {
        commandType: OrderCargoOrderHistoryEventType.CHANGE_RIDE,
        updateRideCommandSequence: performedCommand.updateRideCommandSequence,
      };
  }
};

const createDataItemCargoTaxiBillingModel = (
  cargoTaxiBillingModel: OrderCargoOrderHistoryResponseBillingModel | null,
): BillingModel | null => {
  switch (cargoTaxiBillingModel) {
    case OrderCargoOrderHistoryResponseBillingModel.AB:
      return BillingModel.AB;
    case OrderCargoOrderHistoryResponseBillingModel.ABA:
      return BillingModel.ABA;
    case OrderCargoOrderHistoryResponseBillingModel.OTHER:
      return BillingModel.OTHER;
    case OrderCargoOrderHistoryResponseBillingModel.SABS:
      return BillingModel.SABS;
    default:
      return null;
  }
};

const createDataItem = (
  responseItem: OrderCargoOrderHistoryResponseItem,
): OrderCargoOrderHistoryItem => {
  return {
    author: responseItem.author,
    cargoTaxiBillingModel: createDataItemCargoTaxiBillingModel(
      responseItem.cargoTaxiBillingModel,
    ),
    createdAt: responseItem.createdAt,
    performedCommand: createDataItemPerformedCommand(
      responseItem.performedCommand,
    ),
    taxiCorporationDisplayName: responseItem.taxiCorporationDisplayName,
  };
};

const createData = (
  responseData: OrderCargoOrderHistoryResponseItem[],
): OrderCargoOrderHistoryItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: OrderCargoOrderHistoryResponse,
): OrderCargoOrderHistory => {
  return {
    data: createData(response.data),
  };
};

const cargoOrderHistoryFactory = {
  create,
};

export default cargoOrderHistoryFactory;
